import React from 'react'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'

/**
 * Object that describes a link used in breadcrumbs
 * @typedef {Object} BreadCrumbLink
 * @property {number} id
 * @property {string} title
 * @property {string=} to
 * @property {href=} string
 */

/**
 * Subheader component which includes breadcrumb links for better navigation between pages.
 * @property {BreadCrumbLink[]} breadcrumbItems - an array of breadcrumb items
 * @property {object} breadcrumbLinkComponent - component object for the breadcrumb link
 * @property {*} children - Any React or HTML elements which will be displayed in the subheader as content
 * @example
 * const breadCrumbLinks = [
 *  { title: 'All drives', to: '/' },
 *  { title: 'Drive #342423' },
 * ];
 *
 * <Subheader breadcrumbItems={breadCrumbLinks} breadcrumbLinkComponent={RouterLink}>
 *  This is my subheader stuff here
 * </Subheader>
 */
function Subheader(props) {
  return (
    <Paper elevation={1} square>
      <Box display='flex' justifyContent='space-between' px={3} py={1}>
        <Box>
          <Breadcrumbs aria-label='breadcrumbs' maxItems={3}>
            {props.breadcrumbItems.map((link) =>
              link.to || link.href ? (
                <Link
                  key={link.id}
                  to={link.to}
                  href={link.href}
                  component={props.breadcrumbLinkComponent}
                >
                  {link.title}
                </Link>
              ) : (
                <Typography key={link.id}>{link.title}</Typography>
              )
            )}
          </Breadcrumbs>
        </Box>
        <Box>{props.children}</Box>
      </Box>
    </Paper>
  )
}

export default Subheader
